import InteractionSessionTracking from './interactionSessionTracking';

export const INTERNAL_CLIENT_WINDOW_KEY = 'analyticsInteractionSesssionTrackingClient';

export default class GlobalInteractionSessionTracking {
	static getInstance(): InteractionSessionTracking | undefined {
		let interactionSessionTracking: InteractionSessionTracking | undefined;

		try {
			// Check if InteractionSessionTracking in global window object
			if (INTERNAL_CLIENT_WINDOW_KEY in window) {
				interactionSessionTracking = window[
					INTERNAL_CLIENT_WINDOW_KEY
				] as InteractionSessionTracking;
			} else {
				// Initialise InteractionSessionTracking on global window object
				(window as any)[INTERNAL_CLIENT_WINDOW_KEY] = new InteractionSessionTracking();
				interactionSessionTracking = (window as any)[
					INTERNAL_CLIENT_WINDOW_KEY
				] as InteractionSessionTracking;
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error(
				`Error initialising InteractionSessionTracking - ${error instanceof Error ? error.message : String(error)}`,
			);
		}

		return interactionSessionTracking;
	}
}
